import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import spoorthidoc from '../../../../assets/images/Doctorsimages/dr.spoothi_new.png'
import favicon from "./../../../../assets/images/favicon.ico"

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'

const SpoorthiDoc = () => {
  const navigate = useNavigate();
   useEffect(() => {
       document.title = "Dr. Spoorthi Prasad | Best Senior Homeopathy Doctor in Jayanagar Bangalore";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Spoorthi Prasad (BHMS), Senior Consultant Homeopathy Doctor at H-Cura Multispeciality Clinic, Jayanagar, Bangalore. Expert in thyroid, PCOS, infertility, skin, hair fall, arthritis, diabetes, and holistic care near JP Nagar, Banashankari, Basavanagudi & BTM Layout."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best homeopathy doctor in Jayanagar Bangalore, female homeopathy doctor in Bangalore, senior consultant homeopathy doctor in Jayanagar, holistic doctor in Jayanagar Bangalore, homeopathy doctor for thyroid in Jayanagar, female homeopathy doctor for PCOS in Bangalore, homeopathy doctor for infertility in JP Nagar, homeopathy skin doctor in Banashankari, natural hair fall treatment in Jayanagar Bangalore, holistic treatment doctor in Basavanagudi, natural treatment doctor in Bangalore"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-spoorthi-prasad-senior-homeopathy-doctor-jayanagar-bangalore");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-spoorthi-prasad-senior-homeopathy-doctor-jayanagar-bangalore");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

     const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');

  // Add PDF-specific class to container
  container.classList.add('veenadoc-pdf-mode');

  // Store original styles
  const originalStyles = new Map();

  // Temporarily modify styles for PDF capture
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  // Fix hero section height for PDF
  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  // Ensure images are fully loaded and visible
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  // Wait a moment for styles to apply
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      // Remove PDF-specific class
      container.classList.remove('veenadoc-pdf-mode');

      // Restore original styles
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      // Restore hero section
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Define margins for the PDF
      const marginLeft = 10; // 10mm gap on the left
      const marginRight = 10; // 10mm gap on the right to maintain symmetry and prevent cutting
      const availableWidth = pdfWidth - marginLeft - marginRight;

      // Calculate scaling factor to fit the canvas content within the available width
      const scaleFactor = availableWidth / canvasWidth;

      // Apply the scale factor to both width and height to maintain aspect ratio
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;

      // Calculate the number of pages needed for vertical content overflow
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        // Add image to PDF, using marginLeft for the x coordinate
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.SPOORTHI_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');

      // Remove PDF-specific class
      container.classList.remove('veenadoc-pdf-mode');

      // Restore hero section
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};
  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Spoorthi Prasad</span>
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                  <span className="veenadoc-title-location">Jayanagar, Bangalore</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Senior Consultant Homoeopathy Doctor at H-Cura Multispeciality Clinic with over <strong>8</strong> years of clinical 
                    experience. Recognized as one of the best female homoeopathy doctors in Jayanagar, Bangalore, 
                    providing holistic treatment for thyroid, PCOS, infertility, skin conditions, hair fall, arthritis, 
                    and diabetes near JP Nagar, Banashankari, Basavanagudi & BTM Layout.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')}
            >
              <span className="veenadoc-btn-icon">📞</span>
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div>
            </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={spoorthidoc} alt="Dr. Spoorthi Prasad – Senior Consultant Homeopathy Doctor in Jayanagar, Bangalore" className="veenadoc-doctor-image" title='Dr. Spoorthi Prasad | Best Female Homeopathy Doctor in Jayanagar Bangalore' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Spoorthi Prasad</h2>
                  <p>
                    Dr. Spoorthi Prasad (BHMS) is an experienced and compassionate Senior Consultant Homoeopathy Doctor 
                    at H-Cura Multispeciality Clinic, Jayanagar, Bangalore. With over 8 years of clinical experience, 
                    she has built a strong reputation among patients searching for the best homoeopathy doctor in 
                    Jayanagar, Bangalore, a female homoeopathy doctor near JP Nagar and Banashankari, or a holistic 
                    doctor in Basavanagudi and BTM Layout.
                  </p>
                  <p>
                    Her approach to treatment is deeply rooted in classical homoeopathy, focusing on healing patients' 
                    complaints in a natural and holistic way. Dr. Spoorthi completed her Bachelor of Homoeopathic 
                    Medicine and Surgery (BHMS) from the prestigious Bhagavan Buddha Homoeopathic Medical College 
                    and Hospital, Bengaluru.
                  </p>
                </div>

                {/* Clinical Experience */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Experience & Expertise</h2>
                  <p>
                    Since graduation, she has dedicated her career to homoeopathy, working extensively with H-Cura 
                    Multispeciality Clinic. Over the years, she has treated hundreds of patients with both acute and 
                    chronic conditions, helping them achieve long-term recovery without side effects. For patients 
                    looking for a trusted senior homoeopathy consultant in Jayanagar, Bangalore, her expertise and 
                    compassionate care make her a preferred choice.
                  </p>
                  <p>
                    Her clinical expertise covers a wide range of conditions. She specialises in chronic disease 
                    management, treating illnesses such as <strong>Asthma, Arthritis, Thyroid disorders, Diabetes, Migraines, 
                    Digestive issues, and Hormonal imbalances.</strong>
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">8+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Position:</span>
                      <span className="veenadoc-info-value">Senior Consultant</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Jayanagar, Bangalore</span>
                    </div>
                  </div>
                </div>

                {/* Chronic Disease Management */}
                <div className="veenadoc-article-block">
                  <h2>Chronic Disease Management</h2>
                  <p>
                    Many patients searching online for a homoeopathy doctor for thyroid in Jayanagar, a homoeopathy 
                    doctor for arthritis near JP Nagar, or a natural treatment doctor for chronic pain in Banashankari 
                    often choose to consult her. Her ability to identify the root cause of illness and treat it through 
                    homoeopathy ensures long-term relief and improved quality of life.
                  </p>
                  <p>
                    Her approach goes beyond symptom management, addressing the underlying causes of chronic conditions 
                    to provide lasting healing and improved overall health.
                  </p>
                </div>

                {/* Skin & Hair Treatments */}
                <div className="veenadoc-article-block">
                  <h2>Specialized Skin & Hair Care</h2>
                  <p>
                    At H-Cura Jayanagar, Dr. Spoorthi also provides specialised care in skin and hair treatments. 
                    She has successfully treated patients with acne, pigmentation, psoriasis, eczema, dermatitis, 
                    vitiligo, and other chronic skin conditions. Many people searching for a female homoeopathy 
                    skin doctor in Jayanagar, Bangalore, or a homoeopathy doctor for acne and pigmentation near 
                    BTM Layout and Basavanagudi find relief under her care.
                  </p>
                  <p>
                    In addition, she provides effective solutions for hair-related problems such as chronic dandruff, 
                    scalp infections, premature greying, and severe hair fall, making her one of the most trusted 
                    doctors for holistic hair fall treatment in Jayanagar Bangalore.
                  </p>
                </div>

                {/* Women's Health */}
                <div className="veenadoc-article-block">
                  <h2>Women's Health & Hormonal Care</h2>
                  <p>
                    Her role as a female homeopathy doctor in Jayanagar Bangalore is particularly valued by women 
                    seeking natural and holistic treatments for conditions like PCOS, infertility, irregular periods, 
                    and menopause-related issues. Many patients looking for a female doctor for PCOS in Bangalore 
                    or a homeopathy doctor for infertility near JP Nagar consult her for safe, side-effect-free 
                    alternatives that improve overall reproductive and hormonal health.
                  </p>
                  <p>
                    Her caring nature and empathetic approach ensure that women feel comfortable and supported 
                    throughout their treatment journey.
                  </p>
                </div>

                {/* Holistic Mental Health */}
                <div className="veenadoc-article-block">
                  <h2>Holistic Mind-Body Treatment</h2>
                  <p>
                    Beyond physical health, Dr. Spoorthi believes in the importance of treating the mind and body 
                    together. Patients struggling with stress, anxiety, depression, or sleep disorders often search 
                    for a holistic homeopathy doctor in Bangalore and find her approach highly beneficial. By 
                    addressing both emotional and physical aspects, she helps her patients achieve balance and 
                    harmony in life.
                  </p>
                  <p>
                    Her treatment philosophy is simple yet profound: "Healing patients' complaints in a holistic 
                    and natural way."
                  </p>
                </div>

                {/* Patient Experience */}
                <div className="veenadoc-article-block">
                  <h2>Patient-Centered Care</h2>
                  <p>
                    Her patients consistently describe her as approachable, compassionate, and thorough in her 
                    consultations. She takes the time to listen, understand, and design holistic treatment 
                    plans for each individual. For those who feel unheard in conventional medicine, her style 
                    of care provides reassurance and trust.
                  </p>
                  <p>
                    This is why many online queries such as best homeopathy doctor in Jayanagar, female homeopathy 
                    doctor near Banashankari, holistic doctor in Basavanagudi, natural treatment doctor near JP Nagar, 
                    or senior consultant homeopathy doctor in BTM Layout lead patients directly to her profile.
                  </p>
                </div>

                {/* H-Cura Integration */}
                <div className="veenadoc-article-block">
                  <h2>Integrated Care at H-Cura</h2>
                  <p>
                    At H-Cura Multispeciality Clinic Jayanagar, Dr. Spoorthi works alongside other specialists, 
                    offering patients integrated care in homeopathy, skin and aesthetics, dental health, and 
                    holistic treatments. Her presence as a senior consultant homeopathy doctor in Jayanagar 
                    strengthens the clinic's reputation as one of the best homeopathy clinics in Bangalore.
                  </p>
                  <p>
                    The clinic serves patients not only from Jayanagar but also from surrounding areas like 
                    JP Nagar, Banashankari, Basavanagudi, and BTM Layout.
                  </p>
                </div>

                {/* Lifestyle Disorders */}
                <div className="veenadoc-article-block">
                  <h2>Lifestyle Disorder Management</h2>
                  <p>
                    For patients suffering from lifestyle disorders such as obesity, diabetes, hypertension, 
                    or stress-related conditions, she provides holistic homeopathy solutions that go beyond 
                    symptom management. Many individuals searching for a natural treatment doctor in Jayanagar 
                    Bangalore rely on her expertise to adopt healthier lifestyles while recovering from illnesses.
                  </p>
                  <p>
                    Her ability to combine homeopathy with lifestyle guidance makes her an ideal doctor for 
                    those who want long-term health improvements without depending on harsh medications.
                  </p>
                </div>

                {/* Comprehensive Care */}
                <div className="veenadoc-article-block">
                  <h2>Comprehensive Care for All Ages</h2>
                  <p>
                    Whether it is treating a child with recurrent respiratory infections, helping a young adult 
                    overcome acne and hair fall, supporting a woman struggling with PCOS and infertility, or 
                    guiding an elderly patient with arthritis and diabetes, Dr. Spoorthi provides comprehensive 
                    care that addresses every stage of life.
                  </p>
                  <p>
                    For residents of Jayanagar, JP Nagar, Banashankari, Basavanagudi, BTM Layout, and nearby 
                    Bangalore localities, she is a trusted name for safe, effective, and compassionate homeopathy care.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Spoorthi for Natural Healing</h2>
                  <p>
                    Her mission is to make healthcare natural, holistic, and patient-friendly. By blending her 
                    years of experience with a passion for healing, she ensures that every patient receives 
                    holistic treatment tailored to their physical, emotional, and lifestyle needs.
                  </p>
                  <p>
                    With her growing reputation as one of the best female homeopathy doctors in Bangalore, 
                    she continues to transform patient care at H-Cura Multispeciality Clinic Jayanagar.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower patients with natural healing, holistic wellness, 
                    and compassionate care that addresses the root cause of illness.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Healing patients' complaints in a holistic and natural way"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Spoorthi Prasad's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes that true healing goes beyond temporary relief of symptoms and requires addressing 
                    the root cause of illness. This patient-centric approach has positioned her among the best 
                    holistic homoeopathy doctors in Bangalore, where she provides customised treatments for 
                    individuals of all age groups.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Jayanagar</h4>
                      <p>Primary practice location</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Serving Areas</h4>
                      <p>JP Nagar, Banashankari, Basavanagudi, BTM Layout</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience holistic healthcare with Dr. Spoorthi's holistic approach.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

       <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default SpoorthiDoc
